$(document).ready(function() {
    $('.options:first').show();
    $('.plain-subscription-grid:first').addClass('is-active-header');
    //$('.plan.save-subscribe .option:first').addClass('is-active');
    $('.button_wrapper_outer_wrap .button_wrapper:first button').addClass('button-is-active');
 
$('body').on('click','.plan-header',function () {
      $('.plain-subscription-grid').removeClass('is-active-header');
      $('input[type="radio"]').prop('checked', false);
      $('.options').hide();
      $(this).parents('.plan').find('.options').show();
      $(this).find('input[type="radio"]').prop('checked', true);
      $(this).parents('.plan').find('.option:first').trigger('click');
      $('label.plan-header').removeClass('is-active-header');
      if ($(this).find('input[type="radio"]').is(':checked')) {
      $(this).parents('.plain-subscription-grid').addClass('is-active-header');
      }else{
      $(this).parents('.plain-subscription-grid').removeClass('is-active-header');
      }
})
 
$('body').on('click', '.save-subscribe .option', function () {
   var prdtQty = parseInt($(this).attr('data-qty'));
    var prdctPrice = parseInt($(this).find('.price').attr('data-price'));
    var calculatePrice = prdctPrice * prdtQty;
    var actualPrice = $("span.product-actual-price").attr('data-price');
    var removeDollar = parseInt(actualPrice.replace('$',''));
    var calculateActual  = removeDollar * prdtQty;
    $('.header-popup span.save').text('$' +calculatePrice);
    $('span.product-actual-price').text('$' +calculateActual);
    var DiscountedPrice = $('span.cust-off-price').attr('data-price');
    var removeDollar = parseInt(DiscountedPrice.replace('$',''));
    var savedAmount = removeDollar -10;
    $('.header-popup span.save').attr('data-saved-amount',savedAmount);
    $('.header-popup span.save').text('$'+ savedAmount);
    var multiplyQty = savedAmount * prdtQty;
    $('.header-popup span.save').text('$'+ multiplyQty);
    var actualPrice = $("span.save").text();
    var removeDollar1 = parseInt(actualPrice.replace('$',''));
    var actualcutOff = $('span.product-actual-price').text();
    var removeDollar2 = parseInt(actualcutOff.replace('$',''));
    var savepriceMoney = removeDollar2 - removeDollar1;
    // $('span.saved_amonut span').text('$' +savepriceMoney);
    $('form.qty-atc-form-d9 input#quantity').val(prdtQty);
    var selliingVal = parseInt($('.selling_plan_id--1:first').attr('data-selling-id'));
    console.log(selliingVal);
    $('input#custom-message').attr('value',selliingVal);
    $('product-form.product-form quantity-input.quantity input').val(prdtQty);
    $('.option').removeClass('is-active');
    $(this).addClass('is-active');
    var savesWrapperamount = prdtQty * 10;
    $('.plan.save-subscribe span.saved_amonut span').text('$'+savesWrapperamount);
});



$('body').on('click', '.plan.one-time-purchase .option', function () {
    var prductoneQty = parseInt($(this).find('.price').attr('data-qty'));
  //  console.log('jfd'+prductoneQty)
    $('form.qty-atc-form-d9 input#quantity').val(prductoneQty);
    $('product-form.product-form quantity-input.quantity input').val(prductoneQty);
    $('input#custom-message').attr('value','');
    $('.option').removeClass('is-active');
    $(this).addClass('is-active');
  });
  
$('body').on('click', 'button.button.atc-btn-d9', function (e) {
    e.preventDefault();
    $('product-form.product-form button.product-form__submit.custom_checkout').trigger('click');
});
$('.plan.save-subscribe .option:first').trigger('click');

  // nerver matrix page poup start 
$('body').on('click','.button_wrapper button',function () {
  $('.button_wrapper button').removeClass('button-is-active');
  $(this).addClass('button-is-active');
    $('body').addClass('is-nerver-matrix-active');
    $('.button_wrapper_popu_wrapper-button button').removeClass('active');
    $('.button_wrapper_popup_wrapper-content').hide();
    var dataAttrval = $(this).attr('data-attr');
    $('.button_wrapper_popu_wrapper').show();
    $(`.button_wrapper_popu_wrapper-button button[data-attr= "${dataAttrval}"]`).addClass('active');
    $(`.button_wrapper_popup_wrapper-content[data-attr="${dataAttrval}"]`).show();
    $('.button_wrapper_popu_wrapper').addClass('is-popup-active');
    $('.button_wrapper_popu_wrapper-outer').show();
    });
    $('body').on('click','.button_wrapper_popup_wrapper-content button.button-close-buttn ,.poup-close-icon',function () {
    $('body').removeClass('is-nerver-matrix-active');
    $('.button_wrapper_popu_wrapper').hide();
    $(`.button_wrapper_popu_wrapper-button button`).removeClass('active');
    $('.button_wrapper_popup_wrapper-content').hide();
    $('.button_wrapper_popu_wrapper').removeClass('is-popup-active');
    $('.button_wrapper_popu_wrapper-outer').hide();
})
      

$('body').on('click','.upgrade-popup-flex span.close-popup',function () {
    $(this).parents('.upgrade-popup-wrapper').css('display','none');
})
  $(document).on('click', function (event) {
    if (!$(event.target).closest('.button_wrapper_popu_wrapper, .button_wrapper button').length) {
       $('body').removeClass('is-nerver-matrix-active');
    $('.button_wrapper_popu_wrapper').hide();
    $(`.button_wrapper_popu_wrapper-button button`).removeClass('active');
    $('.button_wrapper_popup_wrapper-content').hide();
    $('.button_wrapper_popu_wrapper').removeClass('is-popup-active');
    $('.button_wrapper_popu_wrapper-outer').hide();
    }
});
   // nerver matrix page poup end 
  // scroll down only in mobile
   if ($(window).width() <= 768) {
    $('a[href="#d9-scroller"]').on('click', function(e) {
    e.preventDefault();
    var target = $('#d9-scroller');
    var offset = -500;  
    $('html, body').animate({
    scrollTop: target.offset().top - offset
    }, 600); 
    });
 }
});
